import { render, staticRenderFns } from "./StatementCodes.vue?vue&type=template&id=2a7d63c1"
import script from "./StatementCodes.vue?vue&type=script&lang=ts"
export * from "./StatementCodes.vue?vue&type=script&lang=ts"
import style0 from "./StatementCodes.vue?vue&type=style&index=0&id=2a7d63c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports